import { BBAPISubError } from "./api-sub-error";

export class ContainerItem {
    barcode: string;
    primerName: string;
    scanTime: number;
    positionCol: number;
    positionRow: number;
    containerItemAware: any
    isInternal: boolean;
    hasDuplicate: boolean;
    hasDifferntMaterials: boolean;
    qcType: string;
    containerItemError: BBAPISubError;
    constructor(barcode: string, scanTime: number, positionCol: number, positionRow: number, isInternal: boolean, carrierItemError: BBAPISubError,) {
        this.barcode = barcode;
        this.scanTime = scanTime;
        this.positionCol = positionCol;
        this.positionRow = positionRow;
        this.isInternal = isInternal;
        this.hasDuplicate = false;
        this.qcType = null;
    }

}
